import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledDraggableOption = styled.div`
  border-radius: 8px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: ${Colors.boxShadow};
  z-index: 9;

  &.dragging {
    z-index: 10;
  }

  &:not(.disabled):hover {
    transform: scale(1.05);
    transition: transform 0.2s;
  }
  &.disabled {
    opacity: 0.5;
    cursor: default;
    background: transparent;
  }
  &.answered {
    border-color: ${Colors.blue};
    box-shadow: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;
